import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  App,
  DashboardPage,
  LoginPage,
  NotFoundPage,
  SignOut,
} from "../domain/app";
import { ProtectedRoute } from "./protected.route";
import * as routes from "./routes";

export const GlobalRouter = () => (
  <BrowserRouter>
    <Routes>
      <Route path={routes.INDEX} element={<App />}>
        <Route index element={<LoginPage />} />
        <Route path={routes.SIGNIN} element={<LoginPage />} />
        <Route
          path={routes.DASHBOARD}
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route path={routes.SIGNOUT} element={<SignOut />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  </BrowserRouter>
);
